import { JSX, Show } from "solid-js";
import { useFeatureFlag } from "../hooks/useFeatureFlag";

interface FeatureGateProps {
    flag: string;
    fallback?: JSX.Element;
    children: JSX.Element;
}

export function FeatureGate(props: FeatureGateProps) {
    const enabled = useFeatureFlag(props.flag);
    return <Show when={enabled()} fallback={props.fallback}>{props.children}</Show>;
}

export default FeatureGate;
